import LabradorTrendingMenu, {
  StandaloneTrendingMenu,
  StandaloneTrendingMenuProps,
} from '@/components/content/TrendingMenu';
import { StandaloneComponent } from '@/types/component';
import deepmerge from 'deepmerge';

const HantStandaloneTrendingMenu: StandaloneComponent<StandaloneTrendingMenuProps> = ({ options, ...props }) => {
  return (
    <StandaloneTrendingMenu
      options={deepmerge<StandaloneTrendingMenuProps['options']>(options, {
        $tag: {
          size: 'small',
        },
      })}
      {...props}
    />
  );
};

export const standalone = HantStandaloneTrendingMenu;

export default LabradorTrendingMenu;
